import React from "react";
import Donatenow from "../imgs/DonateNow.png";
import { GrContact } from "react-icons/gr";

const Contatti = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-gradient-to-r from-white to-amber-50  ">
      <GrContact className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />
      <h1 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        CONTATTI
      </h1>

      <div className="mt-5 max-w-2xl w-full space-y-6 bg-white rounded-xl shadow-lg p-8 text-center z-10">
        <p className="text-lg md:text-xl">
          Per informazioni:{" "}
          <a
            href="mailto:milarte.mi@gmail.com"
            className="text-red-600 underline hover:text-red-800 transition"
          >
            milarte.mi@gmail.com
          </a>{" "}
          -{" "}
          <a
            href="mailto:milarte.mi@pec.it"
            className="text-red-600 underline hover:text-red-800 transition"
          >
            milarte.mi@pec.it
          </a>
        </p>

        <p className="text-lg md:text-xl">
          <a
            href="https://www.giuseppedinardo.it/"
            className="text-red-600 underline hover:text-red-800 transition"
          >
            Giuseppe Dinardo
          </a>
          : +39 338 830 3778
        </p>

        <p className="text-lg md:text-xl">
          MilArte Via Giovanni Scheiwiller, 7 20139 Milano
        </p>

        <div className="mt-6">
          <p className="text-lg font-semibold mb-3">Per donazioni liberali:</p>
          <a className="inline-block transform hover:scale-105 transition duration-300">
            <img
              src={Donatenow}
              alt="Donate Now"
              className="w-2/3 md:w-1/2 mx-auto rounded-lg shadow-lg"
            />
          </a>
          <p className="mt-3 text-gray-700 font-mono">
            IBAN: IT19M0760101600001067558849
          </p>
        </div>
      </div>

      <p className="mt-12 text-gray-500 text-sm md:text-base text-center mb-5">
        © 2025 MilArte. Tutti i diritti riservati.
      </p>
    </div>
  );
};

export default Contatti;
